const sortTable = () => {
    const trAcc = document.querySelectorAll('.accordion-table__body .accordion-table__row')
    const tr = document.querySelectorAll('.table-sort tr')

    for (let i = 0; i < trAcc.length; i++) {
        if (trAcc[i].getAttribute('data-desktop') == '0.00') {
            trAcc[i].style.display = 'none'
        }
    }

    for (let i = 0; i < tr.length; i++) {
        if (tr[i].getAttribute('data-desktop') == '0.00' && tr[i].getAttribute('data-tablet') == '0.00' && tr[i].getAttribute('data-mobile') == '0.00') {
            tr[i].style.display = 'none'
        }
    }

    const getSort = ({ target }) => {
        const order = (target.parentNode.dataset.order = -(target.parentNode.dataset.order || -1));
        const index = [...target.parentNode.cells].indexOf(target);
        const collator = new Intl.Collator(['en', 'ru'], { numeric: true });
        const comparator = (index, order) => (a, b) => order * collator.compare(
            a.children[index].innerHTML,
            b.children[index].innerHTML
        );

        for(const tBody of target.closest('.table-sort').tBodies)
            tBody.append(...[...tBody.rows].sort(comparator(index, order)));
    };

    document.querySelectorAll('.table-sort thead th').forEach(tableTH => tableTH.addEventListener('click', () => getSort(event)));
}

export default sortTable();
